import { FieldStore, ISubFormStore, optional, validateSubForm } from '@tom-ui/utils'
import { makeObservable } from 'mobx'
import { DangerousGoodsSubFormStore, DangerousGoodsSubFormType } from './DangerousGoodsSubFormStore'

export type CargoDetailsSubFormType = {
  isEmpty: boolean
  grossWeight?: number
  vgm?: number
  content?: string
  dangerousGoods?: DangerousGoodsSubFormType
}

const validateWeight = ({
  vgm,
  grossWeight,
}: {
  vgm?: number
  grossWeight?: number
}): string | undefined => {
  return !vgm && !grossWeight ? 'fieldIsRequired' : undefined
}

export class CargoDetailsSubFormStore implements ISubFormStore<CargoDetailsSubFormType> {
  isEmpty: FieldStore<boolean>
  grossWeight: FieldStore<number>
  vgm: FieldStore<number>
  content: FieldStore<string>
  dangerousGoods: DangerousGoodsSubFormStore

  constructor(initialValues?: Partial<CargoDetailsSubFormType>, isFromRestowPage?: boolean) {
    makeObservable(this)

    this.isEmpty = new FieldStore<boolean>(initialValues?.isEmpty ?? true)
    this.grossWeight = new FieldStore<number>(
      initialValues?.grossWeight ?? 0,
      isFromRestowPage
        ? optional()
        : (val): string | undefined =>
            validateWeight({
              grossWeight: val,
              vgm: this.vgm.value,
            }),
    )
    this.vgm = new FieldStore<number>(
      initialValues?.vgm ?? 0,
      isFromRestowPage
        ? optional()
        : (val): string | undefined =>
            validateWeight({
              vgm: val,
              grossWeight: this.grossWeight.value,
            }),
    )
    this.content = new FieldStore<string>(initialValues?.content ?? '')
    this.dangerousGoods = new DangerousGoodsSubFormStore(initialValues?.dangerousGoods)
  }

  validate = () => {
    if (this.isEmpty.value) {
      return true
    }
    return validateSubForm(this)
  }

  get data(): CargoDetailsSubFormType {
    if (this.isEmpty.value) {
      return {
        isEmpty: this.isEmpty.value,
        dangerousGoods: this.dangerousGoods.data,
      }
    }

    return {
      isEmpty: this.isEmpty.value,
      grossWeight: this.grossWeight.value,
      vgm: this.vgm.value,
      content: this.content.value,
      dangerousGoods: this.dangerousGoods.data,
    }
  }
}
